import i18n from '../../i18n/index'
import {
  EXPECTED_REP_CYCLE_MS,
  RUSHER_VD_THRESHOLD_MS,
  STALL_VD_THRESHOLD_MS,
  type RepConfirmationSource,
  type RepVelocitySample,
  type TempoComplianceFlag,
} from './tempoConstants'

/**
 * Velocity Deviation Index:
 *   V_d = Δt_actual − T_expected   (milliseconds)
 */
export function computeVelocityDeviation(actualIntervalMs: number): number {
  return actualIntervalMs - EXPECTED_REP_CYCLE_MS
}

export function classifyVelocityDeviation(deltaMs: number): TempoComplianceFlag {
  if (deltaMs < RUSHER_VD_THRESHOLD_MS) return 'rusher'
  if (deltaMs > STALL_VD_THRESHOLD_MS) return 'stall'
  return 'compliant'
}

export function buildRepVelocitySample(
  repIndex: number,
  actualIntervalMs: number,
  source: RepConfirmationSource,
): RepVelocitySample {
  const delta_ms = computeVelocityDeviation(actualIntervalMs)
  return {
    rep_index: repIndex,
    delta_ms,
    actualIntervalMs,
    expectedIntervalMs: EXPECTED_REP_CYCLE_MS,
    source,
    complianceFlag: classifyVelocityDeviation(delta_ms),
    phase: 'lockout',
  }
}

export function tempoComplianceRate(samples: RepVelocitySample[]): number {
  if (samples.length === 0) return 100
  const compliant = samples.filter((s) => s.complianceFlag === 'compliant').length
  return Math.round((compliant / samples.length) * 1000) / 10
}

export function coachMessageForFlag(flag: TempoComplianceFlag): string | null {
  if (flag === 'stall') return i18n.t('workout.calibration.tracker.velocity.stall')
  return null
}

export function bannerMessageForFlag(flag: TempoComplianceFlag): string | null {
  if (flag === 'rusher') return i18n.t('workout.calibration.tracker.velocity.rusher')
  return null
}
